export default __webpack_public_path__ + "static/media/document-logo-6.f717577d.svg";